import * as actionTypes from 'constants/ActionTypes';

export function getCargoAssigners() {
    return {
        type: actionTypes.GET_CARGO_ASSIGNERS.REQUEST,
    };
}

export function getCargoAssignersPost(realCargoIds) {
    return {
        type: actionTypes.GET_CARGO_ASSIGNERS_POST.REQUEST,
        realCargoIds,
    };
}

export function updateCargoAssigner(item) {
    return {
        type: actionTypes.UPDATE_CARGO_ASSIGNER.REQUEST,
        item,
    };
}

export function searchCargoAssigners(search) {
    return {
        type: actionTypes.SEARCH_CARGO_ASSIGNERS,
        search,
    };
}

export function saveStatusCargoAssigner(item) {
    return {
        type: actionTypes.SAVE_STATUS_CARGO_ASSIGNER,
        item,
    };
}



// WEBPACK FOOTER //
// ./app/actions/cargoes/assigners.js